// extracted by mini-css-extract-plugin
export var container = "section-strong-points-module--container--KT55s";
export var contents = "section-strong-points-module--contents--tUSPh";
export var title = "section-strong-points-module--title--Ybfhg";
export var list = "section-strong-points-module--list--2+lWF";
export var item = "section-strong-points-module--item--zGWME";